import React, { useContext, useState } from 'react';

export type EnergyDrawerData = {
  imageSrc: string;
  altText: string;
  energyRating: string;
  energyInformationSheet?: string;
};

export interface ContextProps {
  energyDrawerData: EnergyDrawerData;
  energyDrawerIsOpen: boolean;
  setEnergyDrawerData: React.Dispatch<React.SetStateAction<EnergyDrawerData>>;
  setEnergyDrawerIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const Context = React.createContext<ContextProps>({} as ContextProps);
export const useEnergyDrawerContext = () => useContext(Context);
export const Provider = ({ children }) => {
  const [energyDrawerData, setEnergyDrawerData] = useState<EnergyDrawerData>({
    imageSrc: '',
    altText: '',
    energyRating: '',
  });
  const [energyDrawerIsOpen, setEnergyDrawerIsOpen] = useState(false);

  return (
    <Context.Provider
      value={{
        energyDrawerData,
        energyDrawerIsOpen,
        setEnergyDrawerData,
        setEnergyDrawerIsOpen,
      }}
    >
      {children}
    </Context.Provider>
  );
};
